import { render } from "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=template&id=61b7f000&scoped=true"
const script = {}

import "./ReLinkAccountsForVouchersShoutPanel.vue?vue&type=style&index=0&id=61b7f000&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b7f000"]])

export default __exports__